import { type ComponentType } from 'react';
import type { z } from 'zod';

import { api } from 'common';

import { BookedAppointmentsVariant } from './variants/BookedAppointments';
import { ConditionsVariant } from './variants/Conditions';
import { DocumentMetadataVariant } from './variants/DocumentMetadata';
import { DocumentSearchVariant } from './variants/DocumentSearch';
import { DocumentTranscriptionsVariant } from './variants/DocumentTranscriptions';
import { EncountersVariant } from './variants/Encounters';
import { LabValuesVariant } from './variants/LabValues';
import { MedicationsVariant } from './variants/Medications';
import { OrdersVariant } from './variants/Orders';
import { PractitionersVariant } from './variants/Practitioners';
import { SurgicalHistoriesVariant } from './variants/SurgicalHistories';

const PatientDataStoreEndpoint = api.FlowDefinition.PatientDataStore.PatientDataStoreEndpoint;
type PatientDataStoreEndpoint = api.FlowDefinition.PatientDataStore.PatientDataStoreEndpoint;

interface PatientDataStoreVariant {
  schema: z.ZodObject<any>;
  Config: ComponentType;
}

export const PatientDataStoreVariants: Record<PatientDataStoreEndpoint, PatientDataStoreVariant> = {
  [PatientDataStoreEndpoint.Practitioners]: PractitionersVariant,
  [PatientDataStoreEndpoint.BookedAppointments]: BookedAppointmentsVariant,
  [PatientDataStoreEndpoint.Conditions]: ConditionsVariant,
  [PatientDataStoreEndpoint.Medications]: MedicationsVariant,
  [PatientDataStoreEndpoint.SurgicalHistories]: SurgicalHistoriesVariant,
  [PatientDataStoreEndpoint.Orders]: OrdersVariant,
  [PatientDataStoreEndpoint.Encounters]: EncountersVariant,
  [PatientDataStoreEndpoint.LabValues]: LabValuesVariant,
  [PatientDataStoreEndpoint.DocumentMetadata]: DocumentMetadataVariant,
  [PatientDataStoreEndpoint.DocumentSearch]: DocumentSearchVariant,
  [PatientDataStoreEndpoint.DocumentTranscriptions]: DocumentTranscriptionsVariant,
};
